import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { Button } from '@pella/sash-framework';
import { useGlobalConfig } from '../../../hooks/use-global-config';
import { useBranchId } from '../../../hooks/use-branch-id';
import { GET_PROMOS_BY_BRANCH } from '../../../enums/graphql';
import { LoadingOverlay } from '../../';
import { isValidArray } from '../../utilities/validations';

import BranchDisclaimerModal from './branch-disclaimer-modal';
import BranchOfferText from './branch-offer-text';

const BranchOffer = ({ className }) => {
	const branchId = useBranchId();
	const [isOpen, setIsOpen] = useState(false);
	const { data, loading } = useQuery(GET_PROMOS_BY_BRANCH, { variables: { branchIDs: branchId }, skip: !branchId ? true : false });

	const { showroom: configData } = useGlobalConfig();

	const onModalTriggerClick = (value) => setIsOpen(value);

	return (
		<div className='branchOffer relative my-7 flex min-h-[450px] bg-black p-6 shadow-lg'>
			{loading && (
				<LoadingOverlay
					fixed={false}
					svgSize={200}
					className='flex-1 bg-black'
				/>
			)}

			{!loading && (
				<div className={`branchOfferBox flex flex-1 flex-col items-center justify-center border border-white p-5 text-center text-white [&_a]:text-white ${className || ''}`}>
					{/* {configData?.promo_heading && <p className='mb-3 text-subtitle-2 text-white'>{configData.promo_heading}</p>} */}
					{!isValidArray(data?.getPromotionsByBranchId) && <p className='text-center text-white xl:text-lg'>No current promotion at this time.</p>}

					{isValidArray(data?.getPromotionsByBranchId) && <BranchOfferText offer={data.getPromotionsByBranchId[0]} />}

					{isValidArray(data?.getPromotionsByBranchId) && (
						<Button
							color='tertiary-alt'
							onClick={() => onModalTriggerClick(true)}
							className='pb-underline text-body-2 mt-4 font-semibold text-white'
						>
							{configData?.disclosure_modal}
						</Button>
					)}
				</div>
			)}

			{isValidArray(data?.getPromotionsByBranchId) && (
				<BranchDisclaimerModal
					isOpen={isOpen}
					onClose={() => onModalTriggerClick(false)}
					disclaimer={data.getPromotionsByBranchId[0]}
				/>
			)}
		</div>
	);
};

export default BranchOffer;

BranchOffer.propTypes = {
	className: PropTypes.string,
};
